import { Route } from "@angular/router";
import { RodadaDeNegociosPage } from "./rodada-de-negocios.page";

export const RodadaDeNegociosRouter: Route[] = [
  { path: 'rodada-de-negocios', component: RodadaDeNegociosPage }
];
